import { render, staticRenderFns } from "./logo-section.vue?vue&type=template&id=14f9cdec&scoped=true&lang=pug&"
import script from "./logo-section.vue?vue&type=script&lang=js&"
export * from "./logo-section.vue?vue&type=script&lang=js&"
import style0 from "./logo-section.vue?vue&type=style&index=0&id=14f9cdec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f9cdec",
  null
  
)

component.options.__file = "logo-section.vue"
export default component.exports